export enum PricingPlanTypes {
  Basic,
  Professional,
  Premium,
  Business,
  Enterprise,
  Custom,
}
